// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2c237d37","39":"ce504413","224":"35a67b5d","375":"d3e2e40d","421":"808d9829","437":"c57da76a","501":"1148230c","724":"e6ca40ae","802":"85bdc057","804":"24b762a0","818":"01051b95","906":"e61a3439","963":"9eb00f7e","990":"5179e08b"}[chunkId] + ".chunk.js";
};